import { createStyles, makeStyles } from "@material-ui/core";
import { COLORS } from "constants/colors";

export interface LabelDisplayedRowsProps {
  from?: number;
  page?: number;
  total?: number;
  count?: number;
}
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "19px",
      height: "19px",
      border: "1px solid #dbdbdb",
      marginRight: "10px",
      textAlign: "center",
      display: "inline-block",
      borderRadius: "2px",
      color: COLORS.primary,
    },
    count: {
      marginLeft: "10px",
      color: COLORS.primary,
    },
    of: {
      color: COLORS.primary,
    },
  })
);
export const LabelDisplayedRows = ({ count, total, page }: LabelDisplayedRowsProps) => {
  const classes = useStyles();

  return (
    <>
      <span className={classes.root}>{Math.ceil(page + 1 / total)}</span>
      <span className={classes.of}>of</span>
      <span className={classes.count}>{Math.ceil(count / total)}</span>
    </>
  );
};
